import React, { Component } from 'react'
import Header from './Header'
import Content from './Content'
import Sidebar from './Sidebar'
import { LanguageProvider } from './lib/LanguageContext'
import Polyglot from 'node-polyglot'
import * as apiCalls from './lib/apiCalls'
import './App.css'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showHideNav: '',
      showHideFooter: '',
      width: 0,
      loggedIn: false,
      userId: '',
      userToken: '',
      runType: 'sis',
      modalOpen: false,
      dropdownOpen: false,
      helpNavState: 'regular',
      hello: true,
      error: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.toggleNavBar = this.toggleNavBar.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
  }

  handleLogin = (userId, userToken) => {
    this.setState(prevState => ({
      ...prevState,
      userId,
      userToken,
      loggedIn: true
    }))
  }

  handleLogout = async () => {
    if(this.state.loggedIn === true) {
      const res = await apiCalls.logout()
      this.setState(prevState => ({
        ...prevState,
        userId: '',
        userToken: '',
        loggedIn: false,
        modalOpen: false,
        dropdownOpen: false
      }))
      localStorage.clear()
    }
  }

  handleChange = (data) => {
    this.setState(data)
  }

  handleModal = (isOpen) => {
    this.setState(prevState => ({
      ...prevState,
      modalOpen: isOpen
    }))
  }

  handleDropdown = (isOpen) => {
    this.setState(prevState => ({
      ...prevState,
      dropdownOpen: isOpen
    }))
  }

  handleError = (error) => {
    this.setState(prevState => ({
      ...prevState,
      error
    }))
  }

  handleClick() {
    if (this.state.width <= 768) {
      this.setState({
        showHideNav: 'showNavBar',
      })
    }
  }

  toggleNavBar(e) {
    if(this.state.width <= 768) {
      window.scrollTo(0,0)
    }
    const navBarState = this.state.showHideNav === 'showNavBar' ? 'hideNavBar' : 'showNavBar'
    this.setState({ showHideNav: navBarState })
  }

  componentWillMount() {
    let savedState = localStorage.getItem('appState')
    if(savedState) {
      this.setState(JSON.parse(savedState))
    } else {
      this.setState({
        showHideNav: 'showNavBar',
        showHideFooter: 'hideFooter',
        loggedIn: false,
        error: false,
        width: 0
      })
    }
    this.setState(prevState => ({
      ...prevState,
      modalOpen: false,
      dropdownOpen: false,
    }))
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions.bind(this))
    document.addEventListener('scroll', this.trackScrolling)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions.bind(this))
    document.removeEventListener('scroll', this.trackScrolling)
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState !== this.state) {
      localStorage.setItem('appState', JSON.stringify(this.state))
    }
}

  updateWindowDimensions() {
    let prevWidth = this.state.width
    this.setState({ width: window.innerWidth })
    if(prevWidth > 768 && window.innerWidth <= 768 && this.state.showHideNav === 'hideNavBar') {
      this.setState( {showHideNav: 'showNavBar' })
    }
  }

  setBottom = (isBottom) => {
    this.setState({ helpNavState: isBottom})
  }

  trackScrolling = async () => {
    const wrappedElement = document.getElementById('Help')
    if(!wrappedElement) {
      return
    }
    let isBottom = wrappedElement.getBoundingClientRect().bottom <= window.innerHeight
    if (isBottom) {
      this.setState({ helpNavState: 'bottom'})
    } else if(this.state.helpNavState === 'bottom' && !isBottom) {
      this.setState({ helpNavState: 'regular'})
    }
  }

  render() {
      return (
        <LanguageProvider>
          <div className={`App container ${this.state.showHideNav} ${this.state.showHideFooter}
            ${this.state.loggedIn === false ? 'notLoggedIn' : ''}`}>
              <Header loggedIn={this.state.loggedIn} institutionId={this.state.userId} handleLogout={this.handleLogout}/>
              <span className={`sidebar-x ${this.state.showHideNav}`} onClick={this.toggleNavBar}>
                <div id="menu-icon">
                  <span />
                  <span />
                  <span />
                  <span />
                </div>
              </span>
              <Sidebar
                showHideNav={this.state.showHideNav}
                handleChange={this.handleChange}
                handleClick={this.handleClick}
              />
              <main id='content' className={`App-content ${this.state.showHideNav}
              ${this.state.modalOpen ? 'openModal' : ''} ${this.state.dropdownOpen ? 'openDropdown' : ''} `} onScroll={this.trackScrolling}>
                <Content showHideNav={this.state.showHideNav} helpNavState={this.state.helpNavState}
                      handleModal={this.handleModal} handleDropdown={this.handleDropdown}
                      institutionId={this.state.userId} token={this.state.userToken} runType={this.state.runType}
                      handleLogin={this.handleLogin} handleLogout={this.handleLogout}
                      isLoggedIn={this.state.loggedIn}
                      mobile={this.state.width <= 768}/>
              </main>
              <footer className='App-footer' />
          </div>
        </LanguageProvider>
      )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js